import { OrganizationKeyName } from "../../../model/Organization";

export const GET_PRODUCT_ADDITION_LIST_FAIL =
  "SHOP:GET_PRODUCT_ADDITION_LIST_FAIL";

export const getProductAdditionListFailAction = (
  organization: OrganizationKeyName
) => ({
  type: GET_PRODUCT_ADDITION_LIST_FAIL as typeof GET_PRODUCT_ADDITION_LIST_FAIL,
  organization,
});

export type GetProductAdditionListFailAction = ReturnType<
  typeof getProductAdditionListFailAction
>;
